import { StatisticTable } from './ui/StatisticTable';
export default StatisticTable;
